/* eslint-disable */
import React, { useEffect, useRef, useState } from "react";
import { FaPause, FaPlay, FaVolumeMute, FaVolumeUp } from "react-icons/fa";
import "./styles.scss";
import axiosInstance from "api/axiosService";
import ReactPlayer from "react-player";

function Home(props) {
  const [settingInfo, setSettingInfo] = useState({});
  const [isPlaying, setIsPlaying] = useState(true);
  const [isMuted, setIsMuted] = useState(true); // Start muted for autoplay compliance
  const [showControls, setShowControls] = useState(false);

  const vidRef = useRef(null);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await axiosInstance.get("/api/setting/info");
      setSettingInfo(response.data.data);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  const togglePlayPause = () => {
    setIsPlaying(!isPlaying);
  };

  const toggleMute = () => {
    setIsMuted(!isMuted);
  };

  const handleVideoError = (error) => {
    console.error("Video error:", error);
  };

  return (
    <>
      <div
        className="video-section"
        onMouseEnter={() => setShowControls(true)}
        onMouseLeave={() => setShowControls(false)}
      >
        <ReactPlayer
          ref={vidRef}
          url="https://spacespeaker.s3.ap-southeast-1.amazonaws.com/uploads/SPACE+SPEAKER+INTRO+FIX.mp4" // Replace with your video URL
          playing={isPlaying}
          muted={isMuted}
          loop={true}
          width="100%"
          height="100%"
          controls={false}
          onError={handleVideoError}
          config={{
            file: {
              attributes: {
                preload: "auto",
                playsInline: true,
              },
            },
          }}
        />

        {/* Custom Controls Overlay */}
        {showControls && (
          <div className="video-controls-overlay">
            <button
              className="control-button play-pause-btn"
              onClick={togglePlayPause}
            >
              {isPlaying ? <FaPause /> : <FaPlay />}
            </button>

            <button className="control-button mute-btn" onClick={toggleMute}>
              {isMuted ? <FaVolumeMute /> : <FaVolumeUp />}
            </button>
          </div>
        )}
      </div>
    </>
  );
}

export default Home;
